<script setup lang="ts">
import { provideInsightSources } from '@/components/home/insights/use-insight-sources';
import {
  provideInsightTracking,
  useInsightPageName,
} from '@/components/home/insights/use-insight-tracking';
import InsightHintCard from '@/components/insights/insight-hint-card.vue';
import InsightHintTree from '@/components/insights/insight-hint-tree.vue';
import type { InsightSavedHintDetail } from '@/types/insights';
import { featureFlags } from '@/featureFlags';

interface Props {
  detail: InsightSavedHintDetail;
}
const props = defineProps<Props>();

provideInsightSources(() => props.detail.sources);
provideInsightTracking({
  pageName: useInsightPageName(),
  insightId: props.detail.insight_id,
  axisId: props.detail.axis_id,
  axisName: props.detail.axis,
});

const isTopicHintPair = featureFlags.ANDEV_10719_INSIGHT_TOPIC_HINT_PAIR;
</script>

<template>
  <div class="saved-insight-detail-body" :class="{ paired: isTopicHintPair }">
    <InsightHintCard v-if="isTopicHintPair" :hint="detail.hint" plain />
    <InsightHintTree v-else :topics="detail.topics" :hints="[detail.hint]">
      <template #hint="{ hint }">
        <InsightHintCard :hint="hint" />
      </template>
    </InsightHintTree>
  </div>
</template>

<style lang="scss" scoped>
.saved-insight-detail-body {
  box-sizing: border-box;
  margin: 24px;
  padding: 24px;
  border-radius: 4px;
  background-color: #fff;

  &.paired {
    padding: 16px 24px;
  }
}
</style>
